import { createAsyncThunk } from '@reduxjs/toolkit'
import * as api from './api'
import { USERS, USER, CREATE_USER, UPDATE_USER, DELETE_USER } from './types'

export const fetchUsers = createAsyncThunk(USERS, api.fetchUsers)
export const fetchUser = createAsyncThunk(USER, api.fetchUser)
export const createUser = createAsyncThunk(CREATE_USER, api.createUser)
export const updateUser = createAsyncThunk(UPDATE_USER, api.updateUser)
export const deleteUser = createAsyncThunk(DELETE_USER, api.deleteUser)
